
const SPIRIT_ADDRESS = '0x5cc61a78f164885776aa610fb0fe1257df78e59b';
const TINSPIRIT_ADDRESS = '0x6caa3e5feba1f83ec1d80ea2eaca37c3421c33a8';
const XTINSPIRIT_ADDRESS = '0x80fe671e580cd1d95b2dcd8ea09233df06c81c7b';
const GAUGE_VAULT_PROXY_MANAGER_ADDRESS = '0x44f7688aba71e462ac44fb2424b6e0cd83e0d47d';
const XTINSPIRIT_TOKEN_DISTRIBUTOR_ADDRESS = '0x6d137d99084f710fad6adf45fd6ef65e617bd4dd';

export {
  SPIRIT_ADDRESS, TINSPIRIT_ADDRESS, XTINSPIRIT_ADDRESS, GAUGE_VAULT_PROXY_MANAGER_ADDRESS, XTINSPIRIT_TOKEN_DISTRIBUTOR_ADDRESS
};
